import { render, staticRenderFns } from "./ServicesCopy.vue?vue&type=template&id=40dd198b&"
import script from "./ServicesCopy.vue?vue&type=script&lang=js&"
export * from "./ServicesCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports